import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box, Button, Skeleton, Typography } from '@mui/material';
import { mergeSx } from 'merge-sx';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { StatisticsCardProps as Props } from './types';

export const StatisticsCard = memo(
  ({
    className,
    icon,
    iconValue,
    title,
    titleSx,
    value,
    valueSx,
    onViewClick,
    isFetching,
  }: Props) => {
    const showViewButton = Boolean(iconValue && onViewClick);

    return (
      <Styled.Wrapper
        className={classnames('StatisticsCard', className)}
        sx={SX.root}
        variant="outlined"
      >
        <Box sx={SX.header}>
          <Typography
            variant="body3"
            color="grey.600"
            fontWeight={300}
            sx={titleSx}
          >
            {title}
          </Typography>
          <Box sx={SX.iconWrapper}>
            <Icon name={icon} size={14} color="common.white" />
          </Box>
        </Box>
        <Box sx={mergeSx(valueSx, SX.valueWrapper)}>
          {isFetching ? (
            <Skeleton animation="wave" variant="rounded" sx={SX.skeleton} />
          ) : (
            <Typography variant="body1" fontWeight={700} color="text.800">
              {value || 0}
            </Typography>
          )}
          {showViewButton && iconValue && (
            <Button
              onClick={onViewClick}
              variant="outlined"
              color="default"
              size="xsmall"
              endIcon={<Icon name={iconValue} size={20} />}
            >
              View
            </Button>
          )}
        </Box>
      </Styled.Wrapper>
    );
  }
);

StatisticsCard.displayName = 'StatisticsCard';
